import React from "react";

const COLOR = {
  green: { bg: "rgba(34,211,165,0.12)", color: "#22D3A5", border: "rgba(34,211,165,0.3)" },
  red:   { bg: "rgba(247,90,90,0.12)",  color: "#F75A5A", border: "rgba(247,90,90,0.3)" },
  amber: { bg: "rgba(247,201,79,0.12)", color: "#F7C94F", border: "rgba(247,201,79,0.3)" },
  blue:  { bg: "rgba(79,142,247,0.12)", color: "#4F8EF7", border: "rgba(79,142,247,0.3)" },
  purple:{ bg: "rgba(155,111,235,0.12)",color: "#9B6FEB", border: "rgba(155,111,235,0.3)" },
  gray:  { bg: "rgba(122,133,163,0.12)",color: "#A6B0CC", border: "rgba(122,133,163,0.3)" },
};

export function Chip({ color = "blue", children, className = "", icon, ...rest }) {
  const c = COLOR[color] || COLOR.blue;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-bold uppercase ${className}`}
      style={{
        fontSize: 11, letterSpacing: "0.04em",
        padding: "3px 10px", border: `1px solid ${c.border}`,
        background: c.bg, color: c.color,
      }}
      {...rest}
    >
      {icon}{children}
    </span>
  );
}

export const STATUS_COLOR = {
  P: "green", A: "red", H: "amber", HO: "purple", S: "gray", L: "blue", F: "gray",
};
